/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { colors } from "utils/styled-constants"

const defaultImageFacebook = "FounderPartners-Social-Share.jpg"
const defaultDescription = "Techaviv Founder Partners"
const author = "@westonbaker"
const defaultImageURLFacebook = `https://founderpartners.vc/${defaultImageFacebook}`

function SEO({ siteTitle, description, lang, meta, title, canonicalLink }) {
  const metaDescription = description || defaultDescription

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${siteTitle}`}
      meta={[
        {
          name: `theme-color`,
          content: colors.white,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:image`,
          content: defaultImageURLFacebook,
        },
        {
          name: `og:image`,
          content: defaultImageURLFacebook,
        },
        {
          name: `og:image:height`,
          content: `4168`,
        },
        {
          name: `og:image:width`,
          content: `4168`,
        },
      ].concat(meta)}
    >
      {!!canonicalLink && <link rel="canonical" href={canonicalLink} />}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  siteTitle: PropTypes.string.isRequired,
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
